export default "__VITE_ASSET__BC03F4AB__"